import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice de la médiane";
const DESCRIPTION =
  "Calculatrice de la médiane pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "de la médiane, calculatrice de la médiane, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/median";
function MedianCalculator() {
  const [numbers, setNumbers] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const numberArray = numbers
        .split(",")
        .map((n) => parseFloat(n.trim()))
        .filter((n) => !isNaN(n));
      if (numberArray.length === 0) {
        setError("Veuillez entrer au moins un nombre");
        setResult("");
        return;
      }
      const sorted = numberArray.sort((a, b) => a - b);
      let median;
      if (sorted.length % 2 === 0) {
        median = (sorted[sorted.length / 2 - 1] + sorted[sorted.length / 2]) / 2;
      } else {
        median = sorted[Math.floor(sorted.length / 2)];
      }
      setResult(median.toFixed(2));
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La <strong>médiane</strong> est la valeur centrale d'une série de nombres classés par ordre croissant.
                  Contrairement à la moyenne, elle n'est pas influencée par les valeurs extrêmes, ce qui en fait un
                  indicateur statistique très robuste. Entrez vos valeurs séparées par des virgules et obtenez la médiane
                  instantanément.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Entrez les nombres séparés par des virgules:</label>
                    <textarea
                      value={numbers}
                      onChange={(e) => setNumbers(e.target.value)}
                      className="form-control"
                      placeholder="1, 2, 3, 4, 5"
                      rows="4"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <p className="p-3 mb-2 bg-success text-white">
                    Médiane: {result}
                  </p>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment calculer la médiane ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Pour calculer la médiane, classez d'abord tous les nombres par ordre croissant.
                        Si la série contient un nombre <strong>impair</strong> de valeurs, la médiane est la valeur du milieu.
                        Si la série contient un nombre <strong>pair</strong> de valeurs, la médiane est la moyenne des deux valeurs centrales.
                      </p>
                      <ul>
                        <li><strong>Exemple impair :</strong> {'{1, 3, 5, 7, 9}'} → médiane = <strong>5</strong></li>
                        <li><strong>Exemple pair :</strong> {'{2, 4, 6, 8}'} → médiane = (4+6)/2 = <strong>5</strong></li>
                      </ul>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Médiane vs Moyenne : quelle différence ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La <strong>moyenne</strong> est sensible aux valeurs extrêmes (valeurs aberrantes). Par exemple,
                        dans la série {'{1, 2, 3, 4, 100}'}, la moyenne vaut 22 alors que la médiane vaut 3.
                        La médiane reflète mieux la valeur « typique » dans des données asymétriques comme les salaires ou les prix immobiliers.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Applications pratiques de la médiane</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La médiane est utilisée dans de nombreux domaines :
                      </p>
                      <ul>
                        <li><strong>Économie :</strong> salaire médian, revenu médian d'un pays</li>
                        <li><strong>Immobilier :</strong> prix médian d'un logement dans une ville</li>
                        <li><strong>Médecine :</strong> valeurs de référence pour les analyses biologiques</li>
                        <li><strong>Statistiques :</strong> analyse de données avec valeurs aberrantes</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default MedianCalculator;
